<template>
   <ObiCard :hideBody="!isEditing">
      <template #header>
         <ObiTitle :icon="RuleCardIcon" :title="title">
            <template #actions>
               <ObiCol class="d-flex">
                  <ObiButton compact size="lg" color="lighter" :icon="EditIcon" @click="$emit('edit', index)" />
                  <v-popover>
                     <ObiButton class="ms-2" size="lg" compact color="lighter" :icon="DeleteIcon" />

                     <template slot="popover">
                        <ObiText class="mb-2 mt-2" v-html="$t('are_you_sure_delete')" />
                        <ObiButton
                           class="ms-2"
                           size="sm"
                           color="danger"
                           :text="$t('actions.yes')"
                           v-close-popover
                           @click="deleteItem"
                        />
                        <ObiButton class="ms-2" size="sm" color="warning" :text="$t('actions.no')" v-close-popover />
                     </template>
                  </v-popover>
               </ObiCol>
            </template>
         </ObiTitle>
      </template>
      <template #body>
         <ObiRow class="p-4">
            <ObiCol>
               <ObiInput
                  @input="onChanged"
                  v-model="formDataSurvey.name"
                  :label="$t('fields.name')"
                  :placeholder="$t('fields.name')"
               />
            </ObiCol>
         </ObiRow>
         <ObiRow class="p-4">
            <ObiSurveyQuestionCard
               v-for="(question, index) in formDataSurvey.questions"
               :key="index"
               :index="index"
               :question="question"
               :is-editing="editingItem === index"
               @change="onChanged"
               @delete="questionDeleted"
               @edit="startEdit"
               class="mt-2"
            />

            <ObiCol col="12" class="text-center mt-4">
               <ObiButton size="lg" outline wider :text="$t('actions.add_question')" @click="addNewQuestion" />
            </ObiCol>
         </ObiRow>
      </template>
   </ObiCard>
</template>

<script>
import { keys, omit } from 'lodash';

import RuleCardIcon from '@/components/Icons/portals/RuleCardIcon';
import EditIcon from '@/components/Icons/portals/EditIcon.svg';
import DeleteIcon from '@/components/Icons/portals/DeleteIcon.svg';
import IconExternalLink from '@/components/Icons/general/IconExternalLink.svg';

import ObiSurveyQuestionCard from '@/components/UI/ObiSurveyQuestionCard';

export default {
   name: 'ObiSurveyCard',
   components: {
      ObiSurveyQuestionCard,
   },
   i18n: {
      messages: {
         tr: {
            last_seen: 'Son Görülme',
            are_you_sure_delete: 'Silmek istediğinize emin misiniz?',
            fields: {
               name: 'Anket Adı',
               state: 'Durum',
               action: 'Aksiyon',
               survey: 'Anket',
               target_url: 'Hedef Adres',
            },
            actions: {
               yes: 'Evet',
               no: 'Hayır',
               add_question: 'Soru Ekle',
            },
         },
         en: {
            last_seen: 'Last Seen',
            are_you_sure_delete: 'Are you sure you want to delete?',
            fields: {
               name: 'Survey Name',
               state: 'Status',
               action: 'Action',
               survey: 'Survey',
               target_url: 'Target URL',
            },
            actions: {
               yes: 'Yes',
               no: 'No',
               add_question: 'Add Question',
            },
         },
      },
   },
   props: {
      survey: {
         type: Object,
      },
      isEditing: {
         type: Boolean,
         default: false,
      },
      index: {
         type: Number,
         default: 0,
      },
   },
   computed: {
      attrs() {
         return omit(this.$attrs, keys(this.$props));
      },
      title() {
         if (this.$props.survey) {
            return this.$props.survey.name ? this.$props.survey.name : 'Yeni Anket';
         }
         return 'Yeni Anket';
      },
   },
   mounted() {
      if (this.$props.survey !== null) {
         this.formDataSurvey = this.$props.survey;
      }
   },
   data() {
      return {
         IconExternalLink,
         RuleCardIcon,
         EditIcon,
         DeleteIcon,
         formDataSurvey: { questions: [], name: null },
         addingNew: false,
         editingItem: null,
         stateSelectOptions: [
            {
               label: 'Girişten Önce',
               value: 'before_login',
            },
            {
               label: 'Giriş Başarılı',
               value: 'login_successful',
            },
            {
               label: 'Giriş Başarısız',
               value: 'login_failed',
            },
         ],
         actionSelectOptions: [
            {
               label: 'Ankete Yönlendir',
               value: 'redirect_to_survey',
            },
            {
               label: "URL'ye Yönlendir",
               value: 'redirect_to_url',
            },
         ],
      };
   },
   methods: {
      async onChanged() {
         this.$emit('change', this.formDataSurvey);
      },
      async deleteItem() {
         this.$emit('delete', this.formDataSurvey);
         this.onChanged();
      },
      async questionDeleted(item) {
         this.formDataSurvey.questions.shift(item);
         this.onChanged();
      },
      async addNewQuestion() {
         this.formDataSurvey.questions.push({ label: {}, answers: [], type: 'single', answer_type: 'text' });
         this.editingItem = this.formDataSurvey.questions.length - 1;
         this.onChanged();
      },
      async startEdit(index) {
         if (this.editingItem === index) {
            this.editingItem = null;
            return;
         }
         this.editingItem = index;
      },
   },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.obi-dcm {
   padding: 20px;
   display: grid;
   grid-gap: 20px;
   border-radius: 8px;
   align-items: center;
   background-color: #f3f8fe;
   justify-content: space-between;
   grid-template-columns: minmax(120px, max-content) 1fr auto;

   .obi-dcm-image {
      text-align: center;

      .obi-image {
         width: unset;
         max-width: 90px;
         max-height: 45px;
         object-fit: cover;
         object-position: center;
      }
   }

   .obi-dcm-content {
      display: grid;
   }

   .obi-dcm-name {
      color: $primary;
      font-size: 1.25rem;
      @include text-truncate;
   }

   .obi-dcm-location {
      font-size: 0.8rem;
   }

   .obi-dcm-status-icon {
      width: 12px;
      height: 12px;
      border-radius: 12px;

      &.online {
         background: #31ba3f;
      }

      &.offline {
         background: #ff8e8e;
      }
   }

   .obi-dcm-action {
   }
}
</style>
